import { useRef, useState } from 'react';
import toast from 'react-hot-toast';
import type { CsvCheck, ParsedCsv } from '../types/whatsapp';
import { parseBulkCsv } from '../utils/parseBulkCsv';
import { validateBulkRows } from '../utils/validateBulkRows';

export function useCsvSheet() {
  const [file, setFile] = useState<File | null>(null);
  const [parsed, setParsed] = useState<ParsedCsv | null>(null);
  const [check, setCheck] = useState<CsvCheck | null>(null);
  const [isParsing, setIsParsing] = useState(false);
  const newestPick = useRef(0);

  const clear = () => {
    newestPick.current += 1;
    setFile(null);
    setParsed(null);
    setCheck(null);
    setIsParsing(false);
  };

  const select = (picked: File) => {
    const pick = ++newestPick.current;
    setFile(picked);
    setCheck(null);
    setIsParsing(true);

    parseBulkCsv(picked)
      .then((result) => {
        if (pick === newestPick.current) setParsed(result);
      })
      .catch(() => {
        if (pick !== newestPick.current) return;
        setParsed(null);
        toast.error('Could not read that file. Remove it and add it again.');
      })
      .finally(() => {
        if (pick === newestPick.current) setIsParsing(false);
      });
  };

  const validate = (variableNumbers: number[]) => {
    if (!parsed) return;

    setCheck(validateBulkRows(parsed, variableNumbers));
  };

  return { file, parsed, check, isParsing, select, clear, validate };
}
